import { Link } from "react-router-dom";
import { URL_COLOR } from "../constants/colors";
import { useTranslation } from "react-i18next";

const NotFoundPage = () => {
  const { t } = useTranslation();
  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1>{t("404 error")}</h1>
      <p>{t("page not exist")}</p>
      <Link to="/" style={{ color: URL_COLOR, textDecoration: "underline" }}>
        {t("Go back to Home")}
      </Link>
    </div>
  );
};

export default NotFoundPage;
